import React, { useState } from "react"
import Modal from "react-modal"
import { Tabs, Tab, Form, Button, Alert, Row, Col, Card } from "react-bootstrap"
import "bootstrap/dist/css/bootstrap.min.css"
import api from "../utils/api"
import styled from "styled-components"
import LoadingOverlay from "react-loading-overlay"
import Select from "react-select"
import logo from "../images/patamedslogo.svg"
import { MdCheckCircle } from "react-icons/md"
import { navigate } from "gatsby"
import axios from 'axios';

const counties = [
  "Mombasa",
  "Kwale",
  "Kilifi",
  "Tana River",
  "Lamu",
  "Taita/Taveta",
  "Garissa",
  "Wajir",
  "Mandera",
  "Marsabit",
  "Isiolo",
  "Meru",
  "Tharaka-Nithi",
  "Embu",
  "Kitui",
  "Machakos",
  "Makueni",
  "Nyandarua",
  "Nyeri",
  "Kirinyaga",
  "Murang'a",
  "Kiambu",
  "Turkana",
  "West Pokot",
  "Samburu",
  "Trans Nzoia",
  "Uasin Gishu",
  "Elgeyo/Marakwet",
  "Nandi",
  "Baringo",
  "Laikipia",
  "Nakuru",
  "Narok",
  "Kajiado",
  "Kericho",
  "Bomet",
  "Kakamega",
  "Vihiga",
  "Bungoma",
  "Busia",
  "Siaya",
  "Kisumu",
  "Homa Bay",
  "Migori",
  "Kisii",
  "Nyamira",
  "Nairobi",
]

const countiesArray = counties.map((county, index) => {
  const data = {
    value: county,
    label: county,
  }
  return data
})

if (typeof window !== `undefined`) {
  window.dataLayer = window.dataLayer || []
}

const customStyles = {
  content: {
    position: 'absolute',
    top: '60%',
    left: '50%',
    transform: 'translate(-50%, -50%)',   
    borderRadius: '10px',
    minWidth: '300px',
    maxWidth: '20%',
    height: '80vh',
    padding: '20px',
    border: '1px solid #ccc',
    backgroundColor: '#fff',
    overflowY: 'auto', // Enable scrolling if content overflows

  },
  overlay: {
    zIndex: "10",
    backgroundColor: "#212529c2",
  },
}

export default function OrderModal({
  open,
  close,
  tab,
  distributor,
  wholesalers,
  drugId,
  item_data,
  item
}) {
  const activeWholesalers = wholesalers?.filter(
    item => item.showWholesaler === true
  )
  const isBrowser = typeof window !== "undefined"

  //console.log("location", isBrowser && window.location.pathname.replace(/\/product\//g, "").replace(/\+/g, " ").toUpperCase())
  const user = isBrowser ? JSON.parse(window.localStorage.getItem("user")) : {}

  //console.log("user", user)

  const [quantity, setQuantity] = useState(distributor?.minQuantity || 0)
  const [phone, setPhone] = useState(user?.phone || "")
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")

  const [selectedSeller, setSelectedSeller] = useState(
    distributor?.distributor.id
  )
  const [minQuantity, setMinQuantity] = useState(distributor?.minQuantity)
  const [sellerType, setSellerType] = useState("distributor")
  const [price, setPrice] = useState(distributor?.price.current)

  const selectSeller = (id, min, type, price) => {
    setSelectedSeller(id)
    setSellerType(type)
    setMinQuantity(min)
    setPrice(price)
  }

  const isSelected = id => {
    return id === selectedSeller ? true : false
  }

  const sendQuote = async e => {
    try {
      e.preventDefault()
      setSuccess("")
      setError("")

      if (quantity < 1) {
        return setError(`Quantity cannot be zero`)
      }
      if (quantity < minQuantity) {
        return setError(`Minimum order quantity is ${minQuantity}`)
      }

      const data = {
        drugId,
        quantity,
        userId: user.id,
        phone: phone

      }

      if (sellerType === "distributor") {
        data.distributorId = selectedSeller
        data.price = price
      } else {
        data.wholesalerId = selectedSeller
        data.price = price
      }

      setLoading(true)
      await api().post(`/quotes`, { ...data })
      setSuccess(`The ${sellerType} distributor will get in touch via email`)
      window.dataLayer.push({ event: 'quote_request', quote_data: data });

      setTimeout(() => {
        setSuccess("")
      }, 10000)
      setLoading(false)
    } catch (error) {
      setLoading(false)
      const message = error.response.data.message
      setError(message)
    }
  }

  const sendOrder = async e => {
    try {
      e.preventDefault()
      setSuccess("")
      setError("")

      if (quantity < 1) {
        return setError(`Quantity cannot be zero`)
      }
      if (quantity < minQuantity) {
        return setError(`Minimum order quantity is ${minQuantity}`)
      }

      const data = {
        drugId,
        quantity,
        userId: user.id,
        item_data,
        phone: phone
      }

      if (sellerType === "distributor") {
        data.distributorId = selectedSeller
        data.price = price
      } else {
        data.wholesalerId = selectedSeller
        data.price = price
      }

      setLoading(true)
      await api().post(`/orders`, { ...data })
      setSuccess(`The ${sellerType} distributor will get in touch via email`)
      window.dataLayer.push({ event: 'order_request', order_data: data });
      window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: "purchase",
        ecommerce: {
          transaction_id: Math.random().toString(16).slice(2) + (new Date()).getTime() + Math.random().toString(16).slice(2),
          affiliation: data.distributorId || data.wholesalerId,
          value: data.price,
          //tax: 4.90,
          //shipping: 5.99,
          currency: "KES",
          //coupon: "SUMMER_SALE",
          items: [
            {
              item_id: drugId,
              item_name: data.item_data.productTradeName,
              affiliation: data.item_data.distributor.distributor.name,
              //coupon: "SUMMER_FUN",
              currency: "KES",
              //discount: data.item_data.distributor.price.discount,
              index: 0,
              //item_brand: "Google",
              item_category: data.item_data.category,
              item_category2: data.item_data.innOfApi,
              // item_category3: "Shirts",
              // item_category4: "Crew",
              // item_category5: "Short sleeve",
              item_list_id: "related_products",
              item_list_name: "Related Products",
              //item_variant: "green",
              //location_id: "L_12345",
              price: price,
              quantity: quantity
            }
          ]
        }
      });
      //console.log("datalayer ", window.dataLayer)
      //console.log("datalayer ", window.dataLayer)
      setTimeout(() => {
        setSuccess("")
      }, 10000)
      setLoading(false)
    } catch (error) {
      setLoading(false)
      const message = error.response.data.message
      setError(message)
    }
  }

  function closeModal() {
    setSuccess("")
    setError("")
    close()
  }

  const handleAddToCart = async () => {
    // Retrieve the 'user' object from localStorage and parse it
    const user = JSON.parse(localStorage.getItem('user'));
    const userId = user ? user.id : null;

    if (!userId) {
      alert('Try Logging in via Email and Password to proceed!');
      navigate('/login');
      return;
    }
  
    // console.log('userId:', userId);
    // console.log('selectedSeller:', selectedSeller);
    // console.log('sellerType:', sellerType);

    try {
      const response = await axios.post(`${process.env.GATSBY_API_URL}/cart/add`, {
        userId,
        drugId: item.id,
        quantity: 1,
        selectedSeller,
        sellerType,
        price: item.price
      });
  
      console.log('Item added to cart:', response.data);
  
      // Update localStorage with the new cart items and count
      localStorage.setItem('cartItems', JSON.stringify(response.data.items));
      localStorage.setItem('cartCount', response.data.items.length);
  
      // Notify other parts of the app about the cart update
      window.dispatchEvent(new Event('cartUpdated'));
  
    } catch (error) {
      console.error('Error adding item to cart:', error.response ? error.response.data : error.message);
    }
  };

  
  
  
  

  return (
    <div>
      <Modal
        isOpen={open}
        onRequestClose={closeModal}
        style={customStyles}
        ariaHideApp={false}
      >
        <Container>
          {!success && (
            <div>
              <h6 style={{ textAlign: "center" }}>{isBrowser && window.location.pathname.replace(/\/product\//g, "").replace(/\+/g, " ").toUpperCase()}</h6>
              <Card
                style={{
                  cursor: "pointer",
                  padding: "10px",
                  margin: "10px 0px",
                  minWidth: "250px",
                  borderRadius: "10px",
                  backgroundColor: isSelected(distributor?.distributor.id) ? "#00bcd44d" : "",
                  border: isSelected(distributor?.distributor.id) ? "2px solid black" : "",
                }}
                onClick={() => {
                  selectSeller(
                    distributor.distributor.id,
                    distributor.minQuantity,
                    "distributor",
                    distributor.price.current
                  );
                }}
              >
                <Row>
                  <Col xs={10}>
                    <h6>{user?.active && distributor?.distributor.name}</h6>
                    {/* <h4>{distributor?.distributor.name}</h4>  */}
                  </Col>
                  {isSelected(distributor?.distributor.id) && (
                    <Col>
                      <MdCheckCircle style={{ color: "green" }} />
                    </Col>
                  )}
                </Row>

                <Row>
                  <Col xs={12} sm={6}>
                    <span style={{ fontWeight: "bold", fontSize:"14px" }}>Price: </span>
                    {(user?.admin && distributor?.showPrice && distributor.price.current) || "on Request"}
                  </Col>
                  <Col xs={12} sm={6}>
                    <span style={{ fontWeight: "bold", fontSize:"14px" }}>Min Order Quantity:</span> {distributor?.minQuantity || 1}
                  </Col>
                  <Col xs={12} sm={6}>
                    <span style={{ fontWeight: "bold", fontSize:"14px" }}>Pack Size:</span> {distributor?.packSize || " "}
                  </Col>
                </Row>
                <ButtonOwner
                  className="mb-3"
                  onClick={() => handleAddToCart(distributor.distributor.id, distributor)}
                >
                  Add To Cart
                </ButtonOwner>
              </Card>

              {activeWholesalers?.length > 0 && (
                <>
                  <h6>Wholesalers</h6>
                  {activeWholesalers.map(item => (
                    <Card
                      key={item.wholesaler.id}
                      style={{
                        cursor: "pointer",
                        padding: "10px",
                        margin: "10px 0px",
                        minWidth: "250px",
                        borderRadius: "10px",
                        backgroundColor: isSelected(item.wholesaler.id) ? "#00bcd44d" : "",
                        border: isSelected(item.wholesaler.id) ? "2px solid black" : "",
                      }}
                      onClick={() => {
                        selectSeller(
                          item.wholesaler.id,
                          item.minQuantity,
                          "wholesaler",
                          item.price.current
                        );
                      }}
                    >
                      <Row>
                        <Col xs={10}>
                          <h6>{item.wholesaler.name}</h6>
                        </Col>
                        {isSelected(item.wholesaler.id) && (
                          <Col>
                            <MdCheckCircle style={{ color: "green" }} />
                          </Col>
                        )}
                      </Row>
                      <Row>
                        <Col xs={12} sm={6}>
                          <span style={{ fontWeight: "bold", fontSize:"14px" }}>Price: </span>
                          {(item?.showPrice && item.price.current) || "on Request"}
                        </Col>
                        <Col xs={12} sm={6}>
                          <span style={{ fontWeight: "bold" , fontSize:"14px"}}>Min Order Quantity:</span> {item.minQuantity || 1}
                        </Col>
                        <Col xs={12} sm={6}>
                          <span style={{ fontWeight: "bold" , fontSize:"14px"}}>Pack Size:</span> {item?.packSize || " "}
                        </Col>
                      </Row>
                      <ButtonOwner
                        className="mb-3"
                        onClick={() => handleAddToCart(item.wholesaler.id, item)}
                      >
                        Add To Cart
                      </ButtonOwner>
                    </Card>
                  ))}
                </>
              )}

              {/* <Tabs
                defaultActiveKey={tab}
                id="uncontrolled-tab-example"
                className="mb-3"
              >
                <Tab eventKey="quote" title="Get Quote">
                  {error ? <Alert variant="danger">{error}</Alert> : ""}
                  {success ? <Alert variant="success">{success}</Alert> : ""}

                  <span>
                    <Form>
                      <p>Quantity:</p>
                      <Form.Control
                        className="my-2"
                        type="text"
                        placeholder="Quantity"
                        value={quantity}
                        onChange={e => setQuantity(e.target.value)}
                        style={{
                          borderColor: quantity < minQuantity ? "red" : "",
                        }}
                      />
                    </Form>
                    <Form>
                      <p>Phone Number:</p>
                      <Form.Control
                        className="my-2"
                        type="text"
                        placeholder="Enter your number"
                        value={phone}
                        onChange={e => setPhone(e.target.value)}
                      />
                    </Form>

                    <Card
                      style={{
                        cursor: "pointer",
                        padding: "10px",
                        margin: "10px 0px",
                        minWidth: "250px",
                        backgroundColor: isSelected(distributor?.distributor.id)
                          ? "#00bcd44d"
                          : "",
                        border: isSelected(distributor?.distributor.id)
                          ? "2px solid black"
                          : "",
                      }}
                      onClick={() => {
                        selectSeller(
                          distributor.distributor.id,
                          distributor.minQuantity,
                          "distributor",
                          distributor.price.current
                        )
                      }}
                    >
                      <Row>
                        <Col xs={10}>
                          <h4>{user?.active && distributor?.distributor.name}</h4>
                          {/* <h4>{distributor?.distributor.name}</h4> */}
                        {/* </Col>
                        {isSelected(distributor?.distributor.id) && (
                          <Col>
                            <MdCheckCircle style={{ color: "green" }} />
                          </Col>
                        )}
                      </Row>

                      <Row>
                        <Col xs={12} sm={6}>
                          <span style={{ fontWeight: "bold" }}>Price: </span>{(user?.admin && distributor?.showPrice && distributor.price.current) || "on Request"}
                        </Col>
                        <Col xs={12} sm={6}>
                          <span style={{ fontWeight: "bold" }}>Min Order Quantity:</span> {distributor?.minQuantity || 1}
                        </Col>
                        <Col xs={12} sm={6}>
                          <span style={{ fontWeight: "bold" }}>Pack Size:</span> {distributor?.packSize || " "}
                        </Col>
                      </Row>
                    </Card>

                    {user?.admin && activeWholesalers?.length > 0 && <h6>Wholesalers</h6>}

                    {user?.admin && activeWholesalers?.map(item => (
                      <Card
                        style={{
                          cursor: "pointer",
                          padding: "10px",
                          margin: "10px 0px",
                          minWidth: "250px",
                          backgroundColor: isSelected(item.wholesaler.id)
                            ? "#00bcd44d"
                            : "",
                          border: isSelected(item.wholesaler.id)
                            ? "2px solid black"
                            : "",
                        }}
                        onClick={() => {
                          selectSeller(
                            item.wholesaler.id,
                            item.minQuantity,
                            "wholesaler",
                            item.price.current
                          )
                        }}
                      >
                        <Row>
                          <Col xs={10}>
                            <h4>{item.wholesaler.name}</h4>
                          </Col>
                          {isSelected(item.wholesaler.id) && (
                            <Col>
                              <MdCheckCircle style={{ color: "green" }} />
                            </Col>
                          )}
                        </Row>
                        <Row>
                          <Col xs={12} sm={6}>
                            <span style={{ fontWeight: "bold" }}>Price: </span>{(item?.showPrice && item.price.current) || "on Request"}
                          </Col>
                          <Col xs={12} sm={6}>
                            <span style={{ fontWeight: "bold" }}>Min Order Quantity:</span> {item.minQuantity || 1}
                          </Col>
                          <Col xs={12} sm={6}>
                            <span style={{ fontWeight: "bold" }}>Pack Size:</span> {item?.packSize || " "}
                          </Col>
                        </Row>
                      </Card>
                    ))}

                    <LoadingOverlay active={loading} spinner text="">
                      <Button
                        style={{
                          width: "100%",
                          backgroundColor: "#03989e",
                          color: "white",
                        }}
                        type="button"
                        onClick={sendQuote}
                        disabled={quantity < minQuantity}
                      >
                        Submit
                      </Button>
                    </LoadingOverlay>
                  </span>
                </Tab>
                <Tab eventKey="order" title="Order">
                  {error ? <Alert variant="danger">{error}</Alert> : ""}
                  {success ? <Alert variant="success">{success}</Alert> : ""}

                  <span>
                    <Form>
                      <p>Quantity:</p>
                      <Form.Control
                        className="my-2"
                        type="text"
                        placeholder="Quantity"
                        value={quantity}
                        onChange={e => setQuantity(e.target.value)}
                        style={{
                          borderColor: quantity < minQuantity ? "red" : "",
                        }}
                      />
                    </Form>
                    <Form>
                      <p>Phone Number:</p>
                      <Form.Control
                        className="my-2"
                        type="text"
                        placeholder="Enter your number"
                        value={phone}
                        onChange={e => setPhone(e.target.value)}
                      />
                    </Form>

                    <Card
                      style={{
                        cursor: "pointer",
                        padding: "10px",
                        margin: "10px 0px",
                        minWidth: "250px",
                        backgroundColor: isSelected(distributor?.distributor.id)
                          ? "#00bcd44d"
                          : "",
                        border: isSelected(distributor?.distributor.id)
                          ? "2px solid black"
                          : "",
                      }}
                      onClick={() => {
                        selectSeller(
                          distributor.distributor.id,
                          distributor.minQuantity,
                          "distributor",
                          distributor.price.current
                        )
                      }}
                    >
                      <Row>
                        <Col xs={10}>
                          {/* <h4>{user?.admin && distributor?.distributor.name}</h4> */}
                          {/* <h4>{user?.active && distributor?.distributor.name}</h4>
                        </Col>
                        {isSelected(distributor?.distributor.id) && (
                          <Col>
                            <MdCheckCircle style={{ color: "green" }} />
                          </Col>
                        )}
                      </Row>
                      <Row>
                        <Col xs={12} sm={6}>
                          <span style={{ fontWeight: "bold" }}>Price: </span>{(distributor?.showPrice && distributor.price.current) || "on Request"}
                        </Col>
                        <Col xs={12} sm={6}>
                          <span style={{ fontWeight: "bold" }}>Min Order Quantity:</span> {distributor?.minQuantity || 1}
                        </Col>
                        <Col xs={12} sm={6}>
                          <span style={{ fontWeight: "bold" }}>Pack Size:</span> {distributor?.packSize || " "}
                        </Col>
                      </Row>
                    </Card>

                    {user?.admin && activeWholesalers?.length > 0 && <h6>Wholesalers</h6>}

                    {user?.admin && activeWholesalers?.map(item => (
                      <Card
                        style={{
                          cursor: "pointer",
                          padding: "10px",
                          margin: "10px 0px",
                          minWidth: "250px",
                          backgroundColor: isSelected(item.wholesaler.id)
                            ? "#00bcd44d"
                            : "",
                          border: isSelected(item.wholesaler.id)
                            ? "2px solid black"
                            : "",
                        }}
                        onClick={() => {
                          selectSeller(
                            item.wholesaler.id,
                            item.minQuantity,
                            "wholesaler",
                            item.price.current
                          )
                        }}
                      >
                        <Row>
                          <Col xs={10}>
                            <h4>{item.wholesaler.name}</h4>
                          </Col>
                          {isSelected(item.wholesaler.id) && (
                            <Col>
                              <MdCheckCircle style={{ color: "green" }} />
                            </Col>
                          )}
                        </Row>
                        <Row>
                          <Col xs={12} sm={6}>
                            <span style={{ fontWeight: "bold" }}>Price: </span>{(item?.showPrice && item.price.current) || "on Request"}
                          </Col>
                          <Col xs={12} sm={6}>
                            <span style={{ fontWeight: "bold" }}>Min Order Quantity:</span> {item.minQuantity || 1}
                          </Col>
                          <Col xs={12} sm={6}>
                            <span style={{ fontWeight: "bold" }}>Pack Size:</span> {item?.packSize || " "}
                          </Col>
                        </Row>
                      </Card>
                    ))}

                    <LoadingOverlay active={loading} spinner text="">
                      <Button
                        style={{
                          width: "100%",
                          backgroundColor: "#03989e",
                          color: "white",
                        }}
                        type="button"
                        onClick={sendOrder}
                      >
                        Submit
                      </Button>
                    </LoadingOverlay>
                  </span>
                </Tab>
              </Tabs> */}
            </div>
          )}

          {success && (
            <>
              <div style={{ textAlign: "center" }}>
                <img src={logo} alt="logo" style={{ width: "150px" }} />

                <h3>Thank You</h3>
                <p>{success}</p>
              </div>
            </>
          )}
        </Container>
      </Modal>
    </div>
  )
}

const Container = styled.div`
  align-items: center;
  justify-content: center;
  z-index: 4000;
`

const ButtonOwner = styled.div`
  background: #03989e;
  padding: 1rem 2rem;
  margin-top: 1rem;
  border-radius: 3rem;
  color: #fff;
  text-align: center;
  cursor: pointer;
  font-size: 1rem;
`

const HeroText = styled.div`
  color: #fff;
  align-items: center;
  text-align: center;
`
const LinkLogo = styled.div`
  width: 60%;
  margin: auto;
  margin-bottom: 2rem;

  @media screen and (min-width: 600px) {
    width: 40%;
  }
  @media screen and (min-width: 800px) {
    width: 30%;
  }
  @media screen and (min-width: 1100px) {
    width: 20%;
  }
  @media screen and (min-width: 1500px) {
    width: 10%;
  }
`

/* const Button = styled(Link)`
  background: red;
  padding: 0.1rem 0.5rem;
  border-radius: 3rem;
  color: #fff;
  margin-bottom: 1rem;

  @media screen and (min-width: 600px) {
    padding: 1rem 5rem;
  }
` */
